import { RouteComponentProps } from 'react-router'
import { Guide } from '../../../global'
import GuidesWidget from '../../widgets/GuidesWidget'

export interface GuidesViewProps
  extends RouteComponentProps<Record<string, unknown>, any> {
  guides: Guide[]
}

export default function GuidesView({ guides }: GuidesViewProps) {
  return <GuidesWidget guides={guides} />
}
